module.exports = __webpack_public_path__ + "img/Bots-icon-white.54d48afc.svg";